<form [formGroup]="editFlorderPlanningForm" class="form-container">
    <eps-date-input
      class="col-12"
      label="ORDERS.FILTER.LABELS.ORDER_DATE"
      formControlName="orderDate"
      [labelWidth]="labelWidth"
      [readonly]="true"
      *ngIf="!panelStatus.isEdit && !panelStatus.isEditable"
    ></eps-date-input>

  <!-- LOADING DATE : date -->
  <eps-date-input
    *ngIf="!panelStatus.createTemplate && !panelStatus.editTemplate"
    [readonly]="!panelStatus.isEdit"
    [showErrors]="panelStatus.isEditable || panelStatus.isEdit"
    [validRanges]="validLoadingDates"
    [labelWidth]="labelWidth"
    class="col-12"
    formControlName="loadingDate"
    label="ORDERS.DETAIL.LABELS.LOADING_DATE"
  ></eps-date-input>

  <!-- UNLOADING DATE : date -->
  <eps-date-input
    *ngIf="!panelStatus.createTemplate && !panelStatus.editTemplate"
    [readonly]="!panelStatus.isEdit"
    [showErrors]="panelStatus.isEditable || panelStatus.isEdit"
    [validRanges]="validUnloadingDates"
    [labelWidth]="labelWidth"
    class="col-12"
    formControlName="unloadingDate"
    label="ORDERS.DETAIL.LABELS.UNLOADING_DATE"
  ></eps-date-input>

  <eps-number-input
    label="ORDERS.DELIVERY.LABELS.RECURRENCE_SINGLE"
    formControlName="quantity"
    [readonly]="!panelStatus.isEdit"
    class="col-12"
    style="width: 400px"
    [labelWidth]="labelWidth"
    [min]="1"
    [max]="99"
    *ngIf="!panelStatus.createTemplate && !panelStatus.isView"
  ></eps-number-input>
  <!-- exchange pallets -->
  <eps-checkbox
    label="ORDERS.DETAIL.LABELS.EXCHANGE_PALLETS"
    formControlName="exchangePallets"
    class="col-12"
    [labelWidth]="labelWidth"
    [readonly]="!panelStatus.isEdit"
    [useIconsInReadonly]="true"
    [showErrors]="panelStatus.isEdit || !panelStatus.isEditable"
    *ngIf="orderContainsCombinations"
  ></eps-checkbox>

  <eps-number-input
    label="ORDERS.DETAIL.LABELS.NUMBER_OF_EXCHANGE_PALLETS"
    formControlName="numberOfExchangePallets"
    class="col-12"
    [labelWidth]="labelWidth"
    max="10000"
    [readonly]="!panelStatus.isEdit"
    [showErrors]="panelStatus.isEdit || !panelStatus.isEditable"
    *ngIf="orderContainsCombinations && editFlorderPlanningForm.value.exchangePallets"
    [clearable]="false"
  ></eps-number-input>

  <!-- save template -->
  <eps-checkbox
    label="ORDERS.MATERIAL.LABELS.CREATE_TEMPLATE"
    formControlName="createTemplate"
    class="col-12"
    *ngIf="authorization.ORDER.CREATE_TEMPLATE && !panelStatus.isView"
    [readonly]="(!panelStatus.isEdit) || panelStatus.createTemplate || panelStatus.editTemplate"
    [useIconsInReadonly]="true"
    [showErrors]="panelStatus.isEdit || !panelStatus.isEditable"
    [labelWidth]="labelWidth"
  ></eps-checkbox>

  <eps-text-input
    label="ORDERS.MATERIAL.LABELS.TEMPLATE_NAME"
    formControlName="templateName"
    [labelWidth]="labelWidth"
    class="col-12"
    *ngIf="editFlorderPlanningForm.value.createTemplate && !panelStatus.isView"
    [readonly]="!panelStatus.isEdit"
    [showErrors]="panelStatus.isEdit || !panelStatus.isEditable"
  ></eps-text-input>

  <div class="buttons" *ngIf="panelStatus.isEdit">
    <div class="hr-thick"></div>
    <eps-button
      type="link"
      label="SHARED.BUTTONS.CANCEL"
      (buttonClick)="cancelClicked.emit()"
      *ngIf="panelStatus.isNew"
    ></eps-button>
    <eps-button
      buttonIcon="check"
      [label]="panelStatus.isNew ? 'ORDERS.PLANNING.BUTTONS.NEXT' : 'ORDERS.DETAIL.BUTTONS.SAVE'"
      (buttonClick)="isValidForm() && nextClicked.emit(editFlorderPlanningForm.value)"
      [disabled]="!isValidForm()"
      submit
    ></eps-button>
  </div>
</form>
